const KEY = "archijo-attribution";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

const clean = (v) =>
  String(v || "")
    .replace(/[\u0000-\u001f\u007f]/g, "")
    .trim()
    .slice(0, 200);

// First-touch: only stored when nothing is stored yet.
export function captureUtm() {
  try {
    if (localStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const values = {};
    let any = false;
    FIELDS.forEach((k) => {
      values[k] = clean(params.get(k));
      if (values[k]) any = true;
    });
    if (!any) return;
    values.first_seen_at = new Date().toISOString();
    localStorage.setItem(KEY, JSON.stringify(values));
  } catch {}
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
}

export function clearAttribution() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}
